import React, { useState } from 'react'

import { PlusOutlined, QuestionCircleFilled } from '@ant-design/icons'
import ListPageHeader from '@shared/ListPageHeader'
import SalesChannelConceptModal from '@shared/sales_channels/SalesChannelConceptModal'
import SalesChannelsList from '@shared/sales_channels/SalesChannelsList'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { salesChannelService } from '@services/admin/salesChannelService'

export default function AdminSalesChannelsList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['data', 'data.sales_channels']}
        guideButton={
          <Tooltip title={t('concepts.sales_channels.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
        actions={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/sales_channels/new')}
          >
            {t('common.button.new')}
          </Button>
        }
      />
      <SalesChannelsList
        service={salesChannelService}
        role="admin"
      />
      <SalesChannelConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}
